import { observer } from 'mobx-react-lite';
import { Callout, DirectionalHint } from '@fluentui/react/lib/Callout';
import type { IPoint } from '@fluentui/react';
import * as React from 'react';

import styles from './TeachingBubbleCallout.scss';
const CALLOUT_GAP_SPACE = 8;

export interface TeachingBubbleCalloutProps {
    shouldShow: boolean;
    target: IPoint;
    text: string;
}

export default observer(function TeachingBubbleCallout(props: TeachingBubbleCalloutProps) {
    const { shouldShow, target, text } = props;

    return (
        <>
            {shouldShow && target.x > 0 && target.y > 0 && (
                <Callout
                    className={styles.callout}
                    target={target}
                    directionalHint={DirectionalHint.bottomCenter}
                    isBeakVisible={false}
                    gapSpace={CALLOUT_GAP_SPACE}>
                    <div className={styles.calloutContainer}>
                        <span className={styles.calloutText}>{text}</span>
                    </div>
                </Callout>
            )}
        </>
    );
});
